import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';


import * as ConceptoModel from './Concepto.model';
import * as TerceroModel from './Tercero.model';
import * as FacturaModel from './CrearFactura.model';
import { OpcionModel } from '../Global/Opcion.model';
import { PrefijoModel } from './Prefijo.model';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { DialogoConfirmacionComponent } from '../DialogConfirmacion/dialogo-confirmacion.component';

import { MatSnackBar,MatSnackBarConfig  } from '@angular/material';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { resolveReflectiveProviders } from '@angular/core/src/di/reflective_provider';



@Component({
	selector: 'crearFactura',
	templateUrl: './CrearFactura.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Camilo
* @since  26/10/2017
**/
export class CrearFacturaComponent {

	public form: FormGroup;
	public formErrors: any;

	public factura: FacturaModel.FacturaModel;
	public prefijo: PrefijoModel;


	public listaPatrimonios: Array<OpcionModel>;
	public listaPrefijos: Array<PrefijoModel>;
	public listaTerceros: Array<TerceroModel.TerceroDetalleModel>;
	public listaConceptos: Array<ConceptoModel.ConceptoOpcionModel>;

	public ntipomonedas = new Array();
	public nescrituras = new Array();


	public conceptos: Array<ConceptoModel.ConceptoModel>;
	public terceros: Array<TerceroModel.TerceroModel>;

	public cnumcont: OpcionModel;
	


	public displayedColumnsConcepto = ['Concepto', 'campo1', 'campo2', 'campo3', 'campo5', 'Unidades', 'ValorUnidad', 'ValorBase', 'Descuento', 'ValorIva', 'ValorImpuesto', 'Eliminar'];
	public displayedColumnsTercero = ['Tercero', 'Porcentaje', 'Eliminar'];

	public exampleDatabaseConcepto: ExampleDatabaseConcepto;
	public exampleDatabaseTercero: ExampleDatabaseTercero;

	public dataSourceConcepto: ExampleDataSourceConcepto;
	public dataSourceTercero: ExampleDataSourceTercero;

	public mostrarConcepto: boolean;

	public valorPorcentaje: number;
	public valorBase: number;
	public vnombre: string
	public sucursal: string
	public cid;
	public dfecmov: Date;
	public iva;
	public fechaDia:Date;
	public fechaDiaHabil:Date;
	public fechaTemporalDiaHabil:Date;
	public fechaTemporal:Date;
	public tipoNegocio:number;

	public ocultar: boolean = false;
	public mensaje: string = "";
	public mensajeResolucion: string = "";

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;

	public bloquearValor:boolean = true;
	public bloquearCampoEscritura:boolean = true;
	public btnConsultar: boolean;

	public valorTemporal: any;

	private valorUVT: number = 0;
	private estadoResolucion: number = 0;


	private validacionUvt: string = "";
	public cantidadCompradores: number;
	public valorInmobiliaaria:number;
	public pdfEscritura: number;
	public pdfCostos: number;
	public nvalida: number;

	private perfil:any;
	private listadoPerfiles:any;
	public horaPermitida: string;



	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog,public dialogo: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.ntipomonedas = new Array();
		this.nescrituras = new Array();

		this.snackBar.dismiss();
		this._serviciosGenerales.get('consultarTipoMonedas', {param:0}).subscribe(
			result =>{
				for(let x of result){
					this.ntipomonedas.push(new OpcionModel(x.vtipomoneda, x.vtipomoneda));
				}
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de IVA", "X");
			});
	}


	ngOnInit() {
		

		if (ServiciosGenerales.temporalCrearFacturaComponent != null) {
			console.log('Antes: ', this);
			this.form = ServiciosGenerales.temporalCrearFacturaComponent.form;
			this.formErrors = ServiciosGenerales.temporalCrearFacturaComponent.formErrors;
			this.factura = ServiciosGenerales.temporalCrearFacturaComponent.factura;
			this.prefijo = ServiciosGenerales.temporalCrearFacturaComponent.prefijo;
			this.listaPatrimonios = ServiciosGenerales.temporalCrearFacturaComponent.listaPatrimonios;
			this.listaPrefijos = ServiciosGenerales.temporalCrearFacturaComponent.listaPrefijos;
			this.listaTerceros = ServiciosGenerales.temporalCrearFacturaComponent.listaTerceros;
			this.listaConceptos = ServiciosGenerales.temporalCrearFacturaComponent.listaConceptos;
			this.conceptos = ServiciosGenerales.temporalCrearFacturaComponent.conceptos;
			this.terceros = ServiciosGenerales.temporalCrearFacturaComponent.terceros;
			this.cnumcont = ServiciosGenerales.temporalCrearFacturaComponent.cnumcont;
			this.exampleDatabaseConcepto = ServiciosGenerales.temporalCrearFacturaComponent.exampleDatabaseConcepto;
			this.exampleDatabaseTercero = ServiciosGenerales.temporalCrearFacturaComponent.exampleDatabaseTercero;
			this.dataSourceConcepto = ServiciosGenerales.temporalCrearFacturaComponent.dataSourceConcepto;

			this.dataSourceTercero = ServiciosGenerales.temporalCrearFacturaComponent.dataSourceTercero;
			this.mostrarConcepto = ServiciosGenerales.temporalCrearFacturaComponent.mostrarConcepto;
			this.valorPorcentaje = ServiciosGenerales.temporalCrearFacturaComponent.valorPorcentaje;
			this.valorBase = ServiciosGenerales.temporalCrearFacturaComponent.valorBase;
			this.vnombre = ServiciosGenerales.temporalCrearFacturaComponent.vnombre;
			this.sucursal = ServiciosGenerales.temporalCrearFacturaComponent.sucursal;

			this.cid = ServiciosGenerales.temporalCrearFacturaComponent.cid;
			this.dfecmov = ServiciosGenerales.temporalCrearFacturaComponent.dfecmov;
			this.iva = ServiciosGenerales.temporalCrearFacturaComponent.iva;
			this.myControl = ServiciosGenerales.temporalCrearFacturaComponent.myControl;
			this.filteredOptions = ServiciosGenerales.temporalCrearFacturaComponent.filteredOptions;
			this.btnConsultar = ServiciosGenerales.temporalCrearFacturaComponent.btnConsultar;
			ServiciosGenerales.temporalCrearFacturaComponent = null;

			this.listaTerceros = new Array();
			this.consultarTerceros();
			this.nescrituras = new Array();
			return;
		}


		this.cnumcont = new OpcionModel('', "");
		this.listaPatrimonios = new Array();

		this.cargarInfo();


		this.filteredOptions = this.myControl.valueChanges
			.startWith(null)
			.map(val => val ? this.filter(val) : this.listaPatrimonios.slice());


		this.inicializarForm();
		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});

		this.cargarComponentesFormulario();
		this.extraerPerfilUsuario();
		this.listadoPerfilesValidar();
	}



	listadoPerfilesValidar(){
		this._serviciosGenerales.get('listadoPerfiles', {}).subscribe(res => {
			this.listadoPerfiles = res[0].perfiles;
			console.log("----->----------<------------>-----------> PerfilesSSSS ",this.listadoPerfiles);
		}, error => {
			this.ocultar = true;
			this.mensaje = "Procesando Información ..";
			this.openSnackBarEspecial("Ocurrió un error al momento de consultar el perfil del Usuario","X");
			console.log(error, '');
		})
	}


	extraerPerfilUsuario(){
		this._serviciosGenerales.get('perfilUsuario', { usuario: this._serviciosGenerales.seguridad.getInfoSesion().usuario}).subscribe(res => {
			this.perfil = res[0].perfil;
			console.log("----->----------<------------>-----------> Perfil ",this.perfil);
		}, error => {
			this.ocultar = true;
			this.mensaje = "Procesando Información ..";
			this.openSnackBarEspecial("Ocurrió un error al momento de consultar el perfil del Usuario","X");
			console.log(error, '');
		})
	}
	cargarComponentesFormulario() {

		this.listaPrefijos = new Array();
		this.listaTerceros = new Array();
		this.listaConceptos = new Array();
		this.conceptos = new Array();
		this.terceros = new Array();

		this.prefijo = new PrefijoModel("", "", "", "", "", "", 0, 0);
		this.factura = new FacturaModel.FacturaModel(new FacturaModel.MchPrefacturaId("", "", "", new Date(), "", "", "", "", 0, 0,"",0,""));
		this.mostrarConcepto = false;
		this.exampleDatabaseTercero = new ExampleDatabaseTercero();
		this.dataSourceTercero = new ExampleDataSourceTercero(this.exampleDatabaseTercero);

		this.valorPorcentaje = 0;
		this.valorBase = 0;

		let dialogRef = new TerceroModel.TerceroModel(new TerceroModel.TerceroId("", "", "", "", "", 100, 0));
		this.exampleDatabaseTercero.addTercero(dialogRef);
		this.sumaPorcentaje();


		this._serviciosGenerales.get('UVT', { fecha: this.factura.id.dfecmov }).subscribe(res => {
			//console.log("----->----------<------------>-----------> ",res);
			this.valorUVT = res[0].VALOR;
		}, error => {
			this.ocultar = true;
			this.mensaje = "Procesando Información ..";

			this.openSnackBarEspecial("Ocurrió un error al momento de consultar el valor UVT","X");
			console.log(error, '');
		})

		
	}


	inicializarForm() {
		this.formErrors = {
			cnumcont: {},
			ciddoc: {},
			dfecmov: {},
			cdescripcion: {},
			ndiasvenc: {},
			vtipomoneda:{},
			trm:{},
			vidEscritura:{}

		};


		this.form = this.formBuilder.group({
			cnumcont: ['', Validators.required],
			ciddoc: ['', Validators.required],
			dfecmov: ['', Validators.required],
			cdescripcion: [''],
			ndiasvenc: ['', Validators.compose([Validators.required, Validators.pattern("[0-9]+"), Validators.maxLength(3)])],
			vtipomoneda: ['COP',Validators.required],
			trm : [
				{
					value   : '',
					disabled: this.bloquearValor
				}, Validators.required
				],
			vidEscritura: [{
				value   : '',
				disabled: this.bloquearCampoEscritura
			}, Validators.required]
		});
	}

	filter(val: string)//: string[]
	{
		if (val == null) {
			val = "";
		}


		let x = this.listaPatrimonios.filter(option => (option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1);

		return x;

	}





	validarDatoNegocio(){
		setTimeout( () => { 
			console.log("Michael Negocio",this.cnumcont.idOpcion,"===",this.cnumcont.labelOpcion.indexOf('-'))
			this.listaPrefijos = new Array();
			this.factura.id.ciddoc = '';
			if(this.cnumcont.labelOpcion.indexOf('-')!=-1){
				this.consultarPrefijos();
			}

		if(this.cnumcont.idOpcion==''){
			this.ocultar = true;
			this.mensaje = "Procesando Información ..";
			this.openSnackBarEspecial('Debe Seleccionar un Negocio: ', 'X');
			return;
		}
		}, 1000 );
		
	}

	eventoConsulta() {
		console.log("ENTRÓ A CONSULTAR ...............");
		this.cargarComponentesFormulario();
		this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0, this.cnumcont.labelOpcion.indexOf('-'));
		
		this.consultarPrefijos();
		this.consultarTerceros();
		this.consultaIva();

		this.form.get('vtipomoneda').setValue('COP');


	}


	habilitarCampoTRM(id: number){
				
		console.log("==========>",this.factura.id.vtipomoneda);

		if(this.factura.id.vtipomoneda!='COP'){
			this.bloquearValor = false;
			this.form.get('trm').enable();
		}
		else{
			this.bloquearValor = true;
			this.form.get('trm').disable();
		}

	
	}


	changePrefijo(prefijo: PrefijoModel) {
		if (this.factura.id.ciddoc != null) {

			this.prefijo = prefijo;
			this.listaConceptos = new Array();
			this.dfecmov = null;
			this.valorBase = 0;
			this.factura.id.ndiasvenc = prefijo.ndiasvenc;

			this._serviciosGenerales.get('listadoConceptos', { cnumcont: this.cnumcont.idOpcion, ciddoc: this.factura.id.ciddoc }).subscribe(

				result => {
					for (let x of result) {
						this.listaConceptos.push(new ConceptoModel.ConceptoOpcionModel(x.ccodcon, x.cdescon, x.nporcentaje, x.nporcentajeimpuestoconsumo, x.ncobraimpuestoconsumo));
					}
					if (this.listaConceptos.length == 0) {
						
						this.ocultar = true;
						this.mensaje = "Procesando Información ..";
						
						this.openSnackBarEspecial('No hay conceptos parametrizados para este prefijo', 'X');
					}
				},
				error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					
					this.ocultar = true;
					this.mensaje = "Procesando Información ..";

					this.openSnackBarEspecial("Ocurrió un error al momento de cargar los terceros", "X");
				});


				this._serviciosGenerales.get('estadoResolucionPrefijo', { cnumcont: this.cnumcont.idOpcion.trim(),prefijo: this.factura.id.ciddoc.trim() }).subscribe(res => {
					//console.log("----->----------<------------>-----------> ",res);
					this.estadoResolucion = res[0].ESTADO;
					console.log("Michael Villamil " + this .estadoResolucion);
							if(this.estadoResolucion !=0){
								this.ocultar = true;
								this.mensaje = "Procesando Información ..";
				
								this.openSnackBarEspecial("La resolución para el prefijo: "+ this.factura.id.ciddoc+ "  no es valida o se encuentra inactiva", "X");
								return;
							}
		
				}, error => {
					this.ocultar = true;
					this.mensaje = "Procesando Información ..";
		
					this.openSnackBarEspecial("Ocurrió un error al momento de consultar el valor UVT","X");
					console.log(error, '');
				})




			this._serviciosGenerales.get('validarFecha', { cnumcont: this.cnumcont.idOpcion, ciddoc: this.factura.id.ciddoc }).subscribe(
				result => {

					for (var x of result) {
						this.dfecmov = new Date(x.dfecmov);
					}

				},
				error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);

				});


				this.nescrituras = new Array();

				this._serviciosGenerales.get('consultarEscrituras', {cnumcont: this.cnumcont.idOpcion, ciddoc: this.factura.id.ciddoc}).subscribe(
					result =>{
						for(let x of result){
							this.nescrituras.push(new OpcionModel(x.vidEscritura, x.vidEscritura));
							this.bloquearCampoEscritura =  true;
							this.form.get('vidEscritura').enable();
						}
					}, 
					error =>{
						var errorMensaje = <any>error;
						console.log('Error al enviar la peticion ', errorMensaje);
						this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de IVA", "X");
					});


			this.exampleDatabaseConcepto = new ExampleDatabaseConcepto();
			this.dataSourceConcepto = new ExampleDataSourceConcepto(this.exampleDatabaseConcepto);

			let dialogRef = new ConceptoModel.ConceptoModel(new ConceptoModel.MchPrefacturadetalleconceptosId("", "", "", "", "", "", "", 1, 0, 0, 0, 0, 0, 0));
			this.exampleDatabaseConcepto.addConcepto(dialogRef);
			this.mostrarConcepto = true;

		}
	}



	addConcepto() {

		let dialogRef = new ConceptoModel.ConceptoModel(new ConceptoModel.MchPrefacturadetalleconceptosId("", "", "", "", "", "", "", 1, 0, 0, 0, 0, 0, 0));
		this.exampleDatabaseConcepto.addConcepto(dialogRef);

	}


	addTercero() {

		let dialogRef = new TerceroModel.TerceroModel(new TerceroModel.TerceroId("", "", "", "", "", 100, 0));
		this.exampleDatabaseTercero.addTercero(dialogRef);

		this.sumaPorcentaje()
	}


	eliminarConcepto(registro) {
		this.exampleDatabaseConcepto.eliminarConcepto(registro);
		this.sumaTotal(null,null);
	}

	crearTercero() {
		//console.log(this);
		ServiciosGenerales.temporalCrearFacturaComponent = this;
		//console.log(ServiciosGenerales.temporalCrearFacturaComponent);
		this._router.navigate(['/Tercero', this.cnumcont.idOpcion.trim()]);
		/*sessionStorage.setItem('facturaTemp', JSON.stringify(this.factura));
		console.log(this.factura.id.cnumcont);*/
	}



	eliminarTercero(registro) {
		this.exampleDatabaseTercero.eliminarTercero(registro);
		this.sumaPorcentaje();
	}


	sumaPorcentaje() {
		let sum = 0;

		for (let i = 0; i < this.exampleDatabaseTercero.data.length; i++) {
			sum += +this.exampleDatabaseTercero.data[i].id.nporcentaje;
			sum=Math.round((sum + Number.EPSILON) * 100) / 100;
		}
		this.valorPorcentaje = sum;

	}


	select(t) {
		console.log(t);
	}


	datosTercero(tercero, posicion) {
		//console.log(tercero, ' < --- > ', posicion);
		for (let i = 0; i < this.exampleDatabaseTercero.data.length; i++) {
			if (posicion.id.cnumid == this.exampleDatabaseTercero.data[i].id.cnumid && posicion.id.ctipid == this.exampleDatabaseTercero.data[i].id.ctipid && posicion.id.cidregter == this.exampleDatabaseTercero.data[i].id.cidregter) {
				//this.exampleDatabaseTercero.data[i].vnombre = tercero.vnombre;	

				this.exampleDatabaseTercero.data[i].id.cnumid = tercero.cnumid;
				this.exampleDatabaseTercero.data[i].id.ctipid = tercero.ctipid;
				this.exampleDatabaseTercero.data[i].id.cidregter = tercero.sucursal;


				//terceros[x].id.cnumid == terceros[y].id.cnumid && terceros[x].id.ctipid == terceros[y].id.ctipid && terceros[x].id.cidregter == terceros[y].id.cidregter)
				//this.exampleDatabaseTercero.data[i] = tercero;
				//console.log(this.exampleDatabaseTercero.data[i]);
				break;
			}

		}
	}
	sumaTotal(registro, ccodcon) {


		this.orgValueChange(this.factura.id.dfecmov);

		let sum = 0;
		let concepto = this.buscarConcepto(ccodcon);

		if (registro != null && registro != undefined)
			this.calculoIva(registro);

		for (let i = 0; i < this.exampleDatabaseConcepto.data.length; i++) {
			sum += (this.exampleDatabaseConcepto.data[i].id.nbase - this.exampleDatabaseConcepto.data[i].id.ndescuento) + this.exampleDatabaseConcepto.data[i].id.niva + this.exampleDatabaseConcepto.data[i].id.nvalorimpuestoconsumo;

		}
		this.valorBase = sum;
	}
	sumaConceptos(registro, ccodcon) {


		this.orgValueChange(this.factura.id.dfecmov);

		let sum = 0;
		let concepto = this.buscarConcepto(ccodcon);

		if (registro != null && registro != undefined)
			this.calculoIva(registro);

		for (let i = 0; i < this.exampleDatabaseConcepto.data.length; i++) {
			sum += (this.exampleDatabaseConcepto.data[i].id.nbase - this.exampleDatabaseConcepto.data[i].id.ndescuento) + this.exampleDatabaseConcepto.data[i].id.niva + this.exampleDatabaseConcepto.data[i].id.nvalorimpuestoconsumo;

		}
		this.valorBase = sum;

		this.calcularImpuesto(registro, ccodcon);

		console.log(registro);
	}


	orgValueChange(x) {

		let data: ConceptoModel.ConceptoModel[] = this.exampleDatabaseConcepto.data;

		this._serviciosGenerales.get('UVT', { fecha: this.factura.id.dfecmov }).subscribe(res => {
			console.log("----->----------<------------>-----------> ", res);

			let conteoConceptoImpuesto = 0;

			for (let temp of data) {
				let concepto = this.buscarConcepto(temp.id.ccodcon);
				if (concepto.ncobraimpuestoconsumo == 1) {
					conteoConceptoImpuesto++;
					if (res.length > 0) {
						this.valorUVT = res[0].VALOR;
						this.calculoBase(data, temp.id.ccodcon);
					}
				}
			}

			if (conteoConceptoImpuesto > 0 && res.length == 0) {
				
				this.ocultar = true;
				this.mensaje = "Procesando Información ..";

				this.openSnackBarEspecial("No se encontró el valor UVT para la fecha: " + this.factura.id.dfecmov.toISOString().substring(0, 10), "X");
				this.validacionUvt = "No se encontró el valor UVT para la fecha: " + this.factura.id.dfecmov.toISOString().substring(0, 10);
			} else {
				this.validacionUvt = "";
			}

		}, error => {
			
			this.ocultar = true;
			this.mensaje = "Procesando Información ..";

			this.openSnackBarEspecial("Ocurrió un error al momento de consultar el valor UVT", "X");
			console.log(error, '');
		})

		console.log(x);


	}
	calculoBase(registro, ccodcon) {

		let concepto = this.buscarConcepto(ccodcon);
		var position = this.exampleDatabaseConcepto.data.indexOf(registro);

		if (concepto.ncobraimpuestoconsumo == 1 && this.exampleDatabaseConcepto.data[position].id.unidades != 1) {

			this.ocultar = true;
			this.mensaje = "Procesando Información ..";

			this.openSnackBarEspecial("La cantidad de unidades no puede ser mayor a 1 cuando el concepto cobra impuesto al consumo", "X");
			this.exampleDatabaseConcepto.data[position].id.unidades = 1;
			return;
		}

		this.exampleDatabaseConcepto.data[position].id.nbase = this.exampleDatabaseConcepto.data[position].id.unidades * this.exampleDatabaseConcepto.data[position].id.valorunidad

		this.calcularImpuesto(registro, ccodcon);

		this.calculoIva(registro);
		this.sumaConceptos(registro, null);
	}


	

	public calcularImpuesto(registro, ccodcon) {
		let concepto = this.buscarConcepto(registro.id.ccodcon);
		var position = this.exampleDatabaseConcepto.data.indexOf(registro);
		
		
		if (concepto != undefined) {
			console.log(concepto.nporcentajeimpuestoconsumo, ' <-----> ',concepto.ncobraimpuestoconsumo);
			if (concepto.ncobraimpuestoconsumo == 1 || (concepto.nporcentajeimpuestoconsumo > 0 && concepto.ncobraimpuestoconsumo == 0)) {

				if ( (concepto.ncobraimpuestoconsumo == 1 && this.exampleDatabaseConcepto.data[position].id.nbase - this.exampleDatabaseConcepto.data[position].id.ndescuento > this.valorUVT) || (concepto.nporcentajeimpuestoconsumo > 0 && concepto.ncobraimpuestoconsumo == 0) ) {
					let valorTemp = (this.exampleDatabaseConcepto.data[position].id.nbase - this.exampleDatabaseConcepto.data[position].id.ndescuento);
					valorTemp = valorTemp * concepto.nporcentajeimpuestoconsumo;
					valorTemp = valorTemp / 100;
					this.exampleDatabaseConcepto.data[position].id.nvalorimpuestoconsumo = valorTemp;
				} else {
					this.exampleDatabaseConcepto.data[position].id.nvalorimpuestoconsumo = 0;
				}
			}
		}
	}


	buscarConcepto(ccodcon) {

		for (let x of this.listaConceptos) {
			if (x.ccodcon == ccodcon) {
				return x;
			}
		}
	}

	calculoIva(registro) {

		var position = this.exampleDatabaseConcepto.data.indexOf(registro);
		var porcentaje;

		for (let i = 0; i < this.listaConceptos.length; i++) {
			if (this.listaConceptos[i].ccodcon == this.exampleDatabaseConcepto.data[position].id.ccodcon) {
				porcentaje = this.listaConceptos[i].nporcentaje;
				//		console.log(this.listaConceptos[i].nporcentaje);
			}
		}

		//console.log(">>>>>>> ",this.iva.ntipo, ' --- ',this.iva.nvalor);

		if (this.iva.ntipo == 1) {
			this.exampleDatabaseConcepto.data[position].id.niva = ((this.exampleDatabaseConcepto.data[position].id.nbase - this.exampleDatabaseConcepto.data[position].id.ndescuento) * porcentaje) / 100
		} else if (this.iva.ntipo == 2) {
			this.exampleDatabaseConcepto.data[position].id.niva = 0;
		} else if (this.iva.ntipo == 3) {

			//console.log( (this.exampleDatabaseConcepto.data[position].id.nbase - this.exampleDatabaseConcepto.data[position].id.ndescuento), ' :::::: VALOR :::::: ',this.iva.nvalor );

			if (this.exampleDatabaseConcepto.data[position].id.nbase - this.exampleDatabaseConcepto.data[position].id.ndescuento > this.iva.nvalor) {
				this.exampleDatabaseConcepto.data[position].id.niva = ((this.exampleDatabaseConcepto.data[position].id.nbase - this.exampleDatabaseConcepto.data[position].id.ndescuento) * porcentaje) / 100
			} else {
				this.exampleDatabaseConcepto.data[position].id.niva = 0;
			}
		} else if (this.iva.ntipo == 4) {
			this.exampleDatabaseConcepto.data[position].id.niva = ((this.exampleDatabaseConcepto.data[position].id.nbase - this.exampleDatabaseConcepto.data[position].id.ndescuento) * this.iva.nvalor) / 100
		}
	}
	private cargarInfo() {

		this._serviciosGenerales.get('horaPermitida', {}).subscribe(res => {
			console.log("/////////////////////// ",res);
			this.horaPermitida = res[0].CVALOR;
			console.log('====>'+this.horaPermitida);
		}, error => {
			this.ocultar = true;
			this.mensaje = "Procesando Información ..";

			this.openSnackBarEspecial("Ocurrió un error al momento de consultar el horario Permitido a Facturar","X");
			console.log(error, '');
		})



		this._serviciosGenerales.get('listaPatrimonios', { param: 0 }).subscribe(
			result => {
				for (let x of result) {
					this.listaPatrimonios.push(new OpcionModel(x.cnumcont, x.vnombrenegocio));
				}
			},
			error => {
				var errorMensaje = <any>error;

				this.ocultar = true;
				this.mensaje = "Procesando Información ..";

				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");
			});

			this._serviciosGenerales.get('fechaSistemaDiaHabil', {param: 0 }).subscribe(result => {
				console.log("----->----------<------------>-----------> ",result);
				this.fechaDiaHabil = result[0].DIAHABIL;
				this.fechaTemporalDiaHabil = this.fechaDiaHabil;  
				console.log("----->----------",this.fechaDiaHabil);
			}, error => {
	
				this.ocultar = true;
				this.mensaje = "Procesando Información ..";
	
				this.openSnackBarEspecial("Ocurrió un error al momento de consultar la fecha del Día","X");
				console.log(error, '');
			})
	
			this._serviciosGenerales.get('fechaSistema', {param: 0 }).subscribe(res => {
				console.log("----->----------<------------>-----------> ",res);
				this.fechaDia = res[0].FECHADIA;
				this.fechaTemporal = this.fechaDia;  
				console.log("----->----------",this.fechaDia);
			}, error => {
				
				this.ocultar = true;
				this.mensaje = "Procesando Información ..";
				
				this.openSnackBarEspecial("Ocurrió un error al momento de consultar la fecha del Día","X");
				console.log(error, '');
			})

			

	}


	consultarPrefijos() {

		this._serviciosGenerales.get('listaPrefijos', { cnumcont: this.cnumcont.idOpcion }).subscribe(
			result => {
				for (let x of result) {
					this.listaPrefijos.push(new PrefijoModel(x.vtexto1, x.vtexto2,
						x.vtexto3, x.vtexto4,x.vtexto5,
						x.cprefijo, x.ndiasvenc, x.tipoPrefijo));
				}
console.log(this.listaPrefijos);
console.log('RESULTTTTTTTTTTTTTTTT');
console.log(result);

			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);

				this.ocultar = true;
				this.mensaje = "Procesando Información ..";

				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});


			this._serviciosGenerales.get('tipoDeInmobiliaria', { contrato: this.cnumcont.idOpcion}).subscribe(
				result => {
					this.tipoNegocio = result[0].tipo;
				}, error => {
					console.log("", error);
	
					this.ocultar = true;
					this.mensaje = "Procesando Información ..";
					this.openSnackBarEspecial("Ocurrió un error al momento de validar la sucursal", "X");
				});


	}


	consultaIva() {
		this._serviciosGenerales.get('consultaCobroIva', { cnumcont: this.cnumcont.idOpcion }).subscribe(
			result => {
				for (let x of result) {
					this.iva = { ntipo: x.ntipo, nvalor: x.nvalor };
				}


			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);

			});
	}


	consultarTerceros() {
		console.log("va a consultar tercero -.-....... ", { cnumcont: this.cnumcont.idOpcion.trim() });
		this._serviciosGenerales.get('listaTerceros', { cnumcont: this.cnumcont.idOpcion.trim() }).subscribe(
			result => {
				console.log("RESULTADO: ",result);
				for (let x of result) {
					this.listaTerceros.push(new TerceroModel.TerceroDetalleModel(this.cnumcont.idOpcion,
						x.cnumid,
						x.ctipid,
						x.vnombre,
						x.sucursal));
				}
				if(this.listaTerceros.length == 0){

					this.ocultar = true;
					this.mensaje = "Procesando Información ..";

					this.openSnackBarEspecial("No se encontraron terceros asociados a este negocio", "X");
				}/*else
					this.snackBar.dismiss();*/
				

			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);

				this.ocultar = true;
				this.mensaje = "Procesando Información ..";

				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los terceros", "X");
			});
	}





	listadoTerceros() {
		let t = new Array();
		for (var a = 0; a < this.listaTerceros.length; a++) {
			t.push(this.listaTerceros[a]);
		}

		return t;
	}


	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		/*snackBarRef.afterDismissed().(()=> {
			console.log("Paso por aqui 2");

			this.ocultar = false;
			this.mensaje = "";
			this

		})*/

	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		

		if (shand.length != 0) {
			for (let i=0;i<shand.length;i++){
			shand[i].style.backgroundColor = "rgb(255 204 214)";
			}
		}
	}




	validarSucursal(terceros: Array<TerceroModel.TerceroModel>, indice: number, cnumcont) {
		if (terceros.length == indice) {
			this.guardar();
		} else {
			this._serviciosGenerales.get('validarSiTieneSucursal', { contrato: cnumcont, tercero: this.terceros[indice].id.cnumid }).subscribe(
				result => {
					if (result[0].cantidad == 0) {
						//console.log("cantidad de registros sucursales " + result[0].cantidad);

						this.ocultar = true;
						this.mensaje = "Procesando Información ..";

						this.openSnackBarEspecial("El tercero " + this.terceros[indice].id.cnumid + " no tiene Sucursales asociadas.", "X");
						return;
					} else {
						this.validarSucursal(terceros, indice + 1, cnumcont);
					}
				}, error => {
					console.log("", error);

					this.ocultar = true;
					this.mensaje = "Procesando Información ..";

					this.openSnackBarEspecial("Ocurrió un error al momento de validar la sucursal", "X");
				});
		}
	}

	validacionAntesDeGuardar() {
		
	

		//console.log("Contrato que llega "+this.cnumcont.idOpcion);
		if (this.form.valid == false) {
			if (this.prefijo.valorCampo1 == null  || (this.prefijo.valorCampo2 == null ) || (this.prefijo.valorCampo3 == null ) || (this.prefijo.valorCampo4 == null ) )
			{
				this.ocultar = true;
				this.mensaje = "Procesando Información ..";

				this.openSnackBarEspecial("Faltan campos por diligenciar en el formulario  del prefijo asociado  ", "X");
				return;
			}
	
    	
		}
	
		
		if(this.listaTerceros.length == 0){
			this.ocultar = true;
			this.mensaje = "Procesando Información ..";

			this.openSnackBarEspecial("No se puede crear la factura porque no se encontraron terceros asociados a este negocio", "X");
			return;
		}/*else{
			this.snackBar.dismiss();
		}*/

		this.terceros = this.exampleDatabaseTercero.data;
		this.validarSucursal(this.terceros, 0, this.cnumcont.idOpcion);
	}

	guardar() {


		console.log("Michael Negocio==============>",this.cnumcont.idOpcion)

		if (this.form.valid == false) {
			if (this.prefijo.valorCampo1 == null  || (this.prefijo.valorCampo2 == null ) || (this.prefijo.valorCampo3 == null ) || (this.prefijo.valorCampo4 == null ) )
			{
				this.ocultar = true;
				this.mensaje = "Procesando Información ..";

				this.openSnackBarEspecial("Faltan campos por diligenciar en el formulario  del prefijo asociado  ", "X");
				return;
			}
		}


		if (this.validacionUvt != '') {
			
			this.ocultar = true;
			this.mensaje = "Procesando Información ..";
			
			this.openSnackBarEspecial(this.validacionUvt, 'X');
			return;
		}

		this.conceptos = this.exampleDatabaseConcepto.data;
		this.terceros = this.exampleDatabaseTercero.data;

		this.ocultar = true;
		this.mensaje = "Procesando Información ..";
		// console.log(this.terceros);

		var d = new Date();
		this.cid = d.getTime();

		// console.log(this.factura);

		let mensaje = this.validaciones(this.conceptos, this.terceros, this.factura);

		if (mensaje != '') {

			this.ocultar = true;
			this.mensaje = "Procesando Información ..";

			this.openSnackBarEspecial(mensaje, "X");
		}
		else {

			this.factura.id.cnumcont = this.cnumcont.idOpcion;
			this.factura.id.cid = this.cid.toString();
			let informacion = {
				factura: {},
				terceros: {},
				conceptos: {}
			}

			for (let x in this.terceros) {
				this.terceros[x].id.cnumcont = this.cnumcont.idOpcion;
				this.terceros[x].id.cid = this.cid.toString();
			}
			for (let x in this.conceptos) {
				this.conceptos[x].id.cnumcont = this.cnumcont.idOpcion;
				this.conceptos[x].id.cid = this.cid.toString();
			}

			informacion.factura = this.factura;
			informacion.terceros = this.terceros;
			informacion.conceptos = this.conceptos;



			console.log("===========>"+informacion)




			this._serviciosGenerales.post('guardar/prefactura', informacion).subscribe(
				result => {
					console.log(result);



					if (result.error == true) {
					
						this.validarSucursal(this.terceros, 0, this.cnumcont.idOpcion);
						
						return;
					}
					let parametros = { USUARIO: this._serviciosGenerales.seguridad.getInfoSesion().usuario, NTIPOEMPRESA: -1,CID: this.cid.toString() }
					this._serviciosGenerales.get('procedure/ALIMENTAR_TABLAS_FACTURACION', parametros).subscribe(
						result => {
							console.log(result, '<-------------------------');
							if (result.error == true) {

								this.ocultar = true;
								this.mensaje = "Procesando Información ..";

								this.openSnackBarEspecial(' ' + result.mensaje, 'X');

								return;
							}
							if (result.mensaje.toLowerCase().trim().indexOf('ok') == -1) {

								this.ocultar = true;
								this.mensaje = "Procesando Información ..";

								this.openSnackBarEspecial('  ' + result.mensaje, 'X');

								return;
							}

							let tipoPrefijo = 0;
							for (let y of this.listaPrefijos) {
								console.log(y.cprefijo, ' ', this.factura.id.ciddoc);
								if (y.cprefijo == this.factura.id.ciddoc) {
									tipoPrefijo = y.tipoPrefijo;
								}
							}
							if (tipoPrefijo != 7) {
								this._serviciosGenerales.descargarArchivo('guardarPdf/factura/cnumcont=' + this.factura.id.cnumcont.trim() +
									'&ciddoc=' + this.factura.id.ciddoc.trim() +
									'&cid=' + this.factura.id.cid.trim() +
									'&ctipo=factura&cidregter=', null);
							}

							this.form.reset();
							this.form.markAsUntouched();
							this.form.markAsPristine();
							this.form.clearAsyncValidators();
							this.form.clearValidators();
							this.ngOnInit();
							this.cargarComponentesFormulario();
							this.inicializarForm();


							setTimeout(() => {
								this._serviciosGenerales.get('consultarNumeroFactura', { vnumliq: this.cid }).subscribe(
									result => {
										console.log("//////////",result[0].factura);

										this._serviciosGenerales.get('consultarVencimientoResolucion', { factura: result[0].factura.trim() }).subscribe(
											result2 => {
													this.ocultar = true;
													this.mensaje = "Procesando Información ..";
													this.openSnackBar("Se guardó la factura exitosamente.." + (tipoPrefijo != 7 ? ", generando PDF .." : ": " + result[0].factura + (result2.length > 0 && result2[0]["descripcion"] != undefined ? result2[0].descripcion : "")+"."), "X");

											}, error => {
												this.ocultar = true;
												this.mensaje = "Procesando Información ..";
												this.openSnackBar("Se guardó la factura exitosamente" + (tipoPrefijo != 7 ? ", generando PDF .." : "."), "X");

											}
										)
									}, error => {
										this.ocultar = true;
										this.mensaje = "Procesando Información ..";
										this.openSnackBar("Se guardó la factura exitosamente" + (tipoPrefijo != 7 ? ", generando PDF .." : "."), "X");

									}
								)

							}, 1000)

						},
						error => {
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);

							this.ocultar = true;
							this.mensaje = "Procesando Información ..";

							this.openSnackBarEspecial("Ocurrió un error al momento de cargar los terceros", "X");

						});

				}, error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);


					this.ocultar = true;
					this.mensaje = "Procesando Información ..";

					this.openSnackBarEspecial("Ocurrió un error al momento de guardar en prefactura", "X");

				});



		}

	}
	bloquearBoton(){
		var count = 1;
		this.guardar();
	}



	consultarDatosEscritura(id: number){

		console.log("PAsooooooooooooooooooooooo")
		this._serviciosGenerales.get('consultarDatosEscritura', { cnumcont: this.cnumcont.idOpcion,videscritura:this.factura.id.vidEscritura , cprefijo:this.factura.id.ciddoc  }).subscribe(
			result => {
				for (let x of result) {
					this.cantidadCompradores = x.cantidadCompradores;
					this.valorInmobiliaaria = x.valorInmobiliaria;
					this.pdfEscritura = x.ndocumento;
					this.pdfCostos =  x. ndocumentocostos;
					this.nvalida = x.nvalida;
				}	
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);

			});
	
	}


	validaciones(conceptos, terceros, factura) {

		let date = new Date();
		console.log(date.getHours()); // hora actual
		console.log(date.getMinutes()); // minutos actuales
 		let horaTemporal =date.getHours()+':'+date.getMinutes();
		
		if(this.tipoNegocio ==1 && this.pdfEscritura!=1){
			return "La escritura seleccionada no tiene cargado PDF de escritura";
		}
		
		if(this.tipoNegocio ==1 && this.pdfCostos!=1){
			return "La escritura seleccionada no tiene cargado Documento de Costos";
		}


		if(this.tipoNegocio ==1 && this.cantidadCompradores != this.terceros.length){
			return "El numero de Compradores no coincide con los de la escritura";
		}			


		
		

		if(this.tipoNegocio ==1 && (this.factura.id.vidEscritura == '' || this.factura.id.vidEscritura == undefined)){
			return "Se debe asociar una escritura cuando el Negocio corresponde a Inmobiliaria.";
		}

	
		if(this.factura.id.vtipomoneda !='COP' && (this.factura.id.trm <= 0 || this.factura.id.trm == null)){
			return "Se debe ingresar valor en TRM cuando el tipo de factura es diferente a COP";
		}

		if(this.factura.id.ciddoc == '' || this.factura.id.ciddoc == null ){
			return "Se debe seleccionar un prefijo";
		}


		if(this.estadoResolucion != 0){
			return "La resolución para el prefijo: "+ this.factura.id.ciddoc+ "  no es valida o se encuentra inactiva";

		}

		//var  numberOfMonths=(new Date(this.fechaTemporal).getFullYear()-this.factura.id.dfecmov.getFullYear())*12+(new Date(this.fechaTemporal).getMonth()-(this.factura.id.dfecmov.getMonth()-1))

		if (conceptos.length == 0 || conceptos.length == null) {
			return 'Debe seleccionar por lo menos un concepto.';
		}


		if (terceros.length == 0 || terceros.length == null) {
			return 'Debe seleccionar por lo menos un tercero.';
		}






		for (let i = 0; i < this.terceros.length; i++) {
			if (terceros[i].id.cnumid == '' || terceros[i].id.cnumid == null) {

				return 'Valide el tercero (' + (i + 1) + '), por que no puede estar vacio el campo "Tercero".';
			}

			if (terceros[i].id.nporcentaje <= 0) {
				return 'Valide el tercero (' + (i + 1) + '), por que el valor del porcentaje de participacion debe ser mayor a cero.';
			}
		}

		for (let x in this.terceros) {
			let conteo = 0;
			for (let y in this.terceros) {
				console.log(terceros[x], ' -- ', terceros[y]);
				if (terceros[x].id.cnumid == terceros[y].id.cnumid &&
					terceros[x].id.ctipid == terceros[y].id.ctipid &&
					terceros[x].id.cidregter == terceros[y].id.cidregter) {
					conteo = conteo + 1;
				}
			}
			if (conteo > 1) {
				return 'El tercero : ' + terceros[x].id.cnumid.trim() + ' con sucursal: ' + terceros[x].id.cidregter + ' está repetido, por favor validar';
			}
		}

		if (this.valorPorcentaje != 100) {
			return 'La suma de los porcentajes no puede ser diferente a 100.';
		}


		for (let i = 0; i < this.conceptos.length; i++) {

			if (!Number.isInteger(conceptos[i].id.unidades) || conceptos[i].id.unidades<=0){
				return 'El valor del campo cantidad debe ser entero y mayor a 0';
			}


			if (conceptos[i].id.ccodcon == '' || conceptos[i].id.ccodcon == null) {

				return 'Valide el concepto (' + (i + 1) + '), por que no puede estar vacio el campo "Concepto".';
			}

			if (conceptos[i].id.nbase <= 0) {
				return 'Valide el concepto (' + (i + 1) + '), por que el valor de la base debe ser mayor a cero.';
			}

			
			if (conceptos[i].id.ndescuento < 0) {
				return 'Valide el concepto (' + (i + 1) + '), por que el valor del descuento debe ser mayor a cero.';
			}

			if (conceptos[i].id.unidades > 999) {
				return 'Valide el concepto (' + (i + 1) + '), por que las unidades no pueden superar tres dígitos.';
			}
			
			if(conceptos[i].id.nbase - conceptos[i].id.ndescuento < 0 ){
				return 'El valor descuento '+conceptos[i].id.ndescuento+' supera el valor base '+ conceptos[i].id.nbase
			}


			if(conceptos[i].id.ndescuento == null){
				return 'El valor descuento no puede estar vacio'
			}

		}


		conceptos.sort(function (a) {
			return parseInt(a.ccodcon);
		});

		var current = null;
		var cnt = 0;

	/*
		for (var i = 0; i < conceptos.length; i++) {
			if (conceptos[i].id.ccodcon != current) {
				if (cnt > 1) {
					for (let i = 0; i < this.listaConceptos.length; i++) {
						if (this.listaConceptos[i].ccodcon == current) {
							return 'El concepto ' + this.listaConceptos[i].cdescon + ' esta repetido varias veces, recuerde que solo puede tener 1 concepto de cada uno.';
						}
					}

				}
				current = conceptos[i].id.ccodcon;
				cnt = 1;
			} else {
				cnt++;
			}
		}
		if (cnt > 1) {
			for (let i = 0; i < this.listaConceptos.length; i++) {
				if (this.listaConceptos[i].ccodcon == current) {
					return 'El concepto ' + this.listaConceptos[i].cdescon + ' esta repetido  varias  veces, recuerde que solo puede tener 1 concepto de cada uno.';
				}
			}
		}

*/


		let valorTotal = 0;
		let valorDescuento = 0;
		for (let x of this.conceptos) {
			valorTotal = valorTotal + x.id.nbase;
			valorDescuento = valorDescuento + x.id.ndescuento;
		}

		valorTotal = valorTotal - valorDescuento;

		console.log(valorDescuento);
		console.log(valorTotal);
		console.log(this.conceptos);

		/*
		if (valorTotal == 0) {
			return 'No se puede crear una factura con valor 0';
		}
		*/
		if (valorTotal < 0) {
			return 'No se puede crear una factura con valor en negativo';
		}

		if(this.tipoNegocio ==1 && this.valorInmobiliaaria != valorTotal){
			return "El valor de la factura no coincide con el de la escritura";
		}			
		if(this.tipoNegocio ==1 && !this.listadoPerfiles.toString().includes(this.perfil.toString()) && this.nvalida!=1){
			return "La escritura no cuenta con la validación completa del control de escritua, por favor validar.";
		}

		return '';
	}

	mostrarDialogoDescartar(): void {
		
		if(this.factura.id.vtipomoneda =='COP'){
			this.bloquearBoton();
		}
	else{

		this.dialogo
		  .open(DialogoConfirmacionComponent, {
			
			data: '¿Está seguro de crear la factura en '+this.factura.id.vtipomoneda
		  })
		  .afterClosed()
		  .subscribe((confirmado: Boolean) => {
			if (confirmado) {
				this.bloquearBoton();
			} 
		  });
		}
	}

}





export class ExampleDataSourceConcepto extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: ExampleDatabaseConcepto) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<ConceptoModel.ConceptoModel[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: ConceptoModel.ConceptoModel) => {
				let searchStr = (item.id.ccodcon).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}


export class ExampleDatabaseConcepto {
	/** Stream that emits whenever the data has been modified. */
	dataChange: BehaviorSubject<ConceptoModel.ConceptoModel[]> = new BehaviorSubject<ConceptoModel.ConceptoModel[]>([]);

	get data(): ConceptoModel.ConceptoModel[] {
		return this.dataChange.value;
	}


	addConcepto(concepto: ConceptoModel.ConceptoModel) {
		const copiedData = this.data.slice();
		copiedData.push(concepto);
		this.dataChange.next(copiedData);
	}

	eliminarConcepto(concepto: ConceptoModel.ConceptoModel) {
		const copiedData = this.data.slice();
		copiedData.splice(copiedData.indexOf(concepto), 1);
		this.dataChange.next(copiedData);
	}
}


export class ExampleDataSourceTercero extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: ExampleDatabaseTercero) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<TerceroModel.TerceroModel[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: TerceroModel.TerceroModel) => {
				let searchStr = (item.id.cnumcont).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}


export class ExampleDatabaseTercero {
	/** Stream that emits whenever the data has been modified. */
	dataChange: BehaviorSubject<TerceroModel.TerceroModel[]> = new BehaviorSubject<TerceroModel.TerceroModel[]>([]);

	get data(): TerceroModel.TerceroModel[] {
		return this.dataChange.value;
	}


	addTercero(tercero: TerceroModel.TerceroModel) {
		//console.log('Agrega tercero: ', tercero);
		const copiedData = this.data.slice();
		copiedData.push(tercero);
		this.dataChange.next(copiedData);

	}

	eliminarTercero(tercero: TerceroModel.TerceroModel) {
		const copiedData = this.data.slice();
		copiedData.splice(copiedData.indexOf(tercero), 1);
		this.dataChange.next(copiedData);

	}




}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearFactura/CrearFactura.component.ts